import { type TranslationTree } from '@/i18n/types';

export const messages = {
  tabs: {
    all: 'Todos',
    draft: 'Rascunhos',
    in_review: 'Em análise',
    approved: 'Publicados',
    rejected: 'Recusados',
    canceled: 'Cancelados',
  },
  status: {
    draft: 'Rascunho',
    in_review: 'Em análise',
    approved: 'Publicado',
    rejected: 'Recusado',
    canceled: 'Cancelado',
  },
  eventType: {
    running: 'Corrida',
    cycling: 'Ciclismo',
    swimming: 'Natação',
    triathlon: 'Triathlon',
    groupTraining: 'Treino coletivo',
    notListed: 'Outro',
  },
  recurrence: {
    daily: 'Diário',
    weekly: 'Semanal',
    monthly: 'Mensal',
  },
} satisfies TranslationTree;
